import sdkInstanceProvider from "../../providers/sdkInstanceProvider";
import clientConfigurationProvider from "../../providers/clientConfigurationProvider";
import { ServiceError, SdkError } from "../errors";
import isServiceError from "./isServiceError";

export default async ({ productId, colourWayId, variantId }) => {
  const sdkInstance = await sdkInstanceProvider("savedItems");
  const { addItemRequestTimeout } = clientConfigurationProvider();

  const item =
    variantId !== null
      ? {
          productId,
          variantId
        }
      : {
          productId,
          colourWayId
        };

  try {
    const { data } = await sdkInstance.addItem({
      item,
      requestOptions: {
        timeout: addItemRequestTimeout
      }
    });

    return data;
  } catch (e) {
    if (isServiceError(e)) {
      throw new ServiceError(e);
    }
    throw new SdkError(e);
  }
};
